import React, { useEffect, useState, useContext } from 'react'
import { hoistHocStatic, PluginContext } from '@flamingo_tech/funkgo'
import { hasWebviewToNativeFlag, clearWebviewToNativeFlag } from '@utils/webviewToNativeFlagUtils'

// 可以触发visibilitychange方法的场景有2中: 1. 原生页面返回webview页面; 2.webview页面从后台切前台
// 当前监听只需要监听原生返回webview, 所以查看是否有webview跳转原生的flag
const usePageBackObserver = () => {
  const [pageBackTime, setPageBackTime] = useState(null)
  const plugin = useContext(PluginContext)
  const isApp = plugin.$detector && plugin.$detector.isApp()
  
  useEffect(() => {
    const handleRefresh = () => {
      if (isApp && !document.hidden) {
        const hasFlag = hasWebviewToNativeFlag(plugin.$storage)
        if (hasFlag) {
          setPageBackTime(Date.now())
          clearWebviewToNativeFlag(plugin.$storage)
        }
      }
    }
    const isObserverAvailable = window && window.document

    if (isObserverAvailable) {
      document.addEventListener('visibilitychange', handleRefresh)
    }

    return () => {
      if (isObserverAvailable) {
        document.removeEventListener('visibilitychange', handleRefresh)
      }
    }
  })

  return pageBackTime
}

const withPageBackObserver = Component => {
  const WrappedComponent = props => {
    const pageBackTime = usePageBackObserver()

    return (
      <Component {...props} pageBackTime={pageBackTime}></Component>
    )
  }

  WrappedComponent.displayName = `withPageBackObserver(${Component.displayName || Component.name})`
  hoistHocStatic(WrappedComponent, Component)
  return WrappedComponent
}

export {
  usePageBackObserver
}

export default withPageBackObserver


